import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceView from "../../../components/maintenance/view/view";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as podcastsGroupsActions from "../../../redux/actions/podcastsGroups";
// Styles
import "./view.css";

const PodcastsGroupsView = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);
  const user = useSelector(state => state.authReducer.user);

  // Set consts and vars
  const page = "podcasts_groups";
  const itemNameSingular = "Grup de Podcast";

  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
  }, []);

  // Set grid config
  const filters = [
    `title`,
    `subtitle`,
    `programming`,
    `priority`,
    `enabled`,
  ];
  const sorters = filters;
  const columns = [
    { 
      name: "files_1",
      width: `100px`,
      header: {
        dataType: "image",
        placeholder: "Imatge",
        textAlign: "center",
        disabled: true,
      },
      style: {
        textAlign: "center",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
      }
    },
    { 
      name: "title",
      header: {
        dataType: "string",
        placeholder: "Títol",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "subtitle",
      width: `250px`,
      header: {
        dataType: "string",
        placeholder: "Sub-títol",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "programming",
      width: `250px`,
      header: {
        dataType: "string",
        placeholder: "Programació",
        textAlign: "left",
      },
      style: {
        textAlign: "left",       // Alinea el texto a la izquierda
        overflow: "hidden",      // Oculta cualquier desbordamiento fuera de la celda
        textOverflow: "clip",    // Desactiva los tres puntos (opcional)
        whiteSpace: "normal",    // Permite que el texto se ajuste en varias líneas
        wordBreak: "break-word", // Asegura que las palabras largas se corten si es necesario
      }
    },
    { 
      name: "priority",
      width: `120px`,
      header: {
        dataType: "integer",
        placeholder: "Prioritat",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
    { 
      name: "enabled",
      width: `105px`,
      header: {
        dataType: "boolean",
        placeholder: "Habilitat",
        textAlign: "center",
      },
      style: {
        textAlign: "center",
        overflow: "hidden",         // Oculta el contenido que sobresale
        textOverflow: "ellipsis",   // Muestra "..." si el texto es demasiado largo
        whiteSpace: "nowrap",       // Impide que el texto se divida en varias líneas
      }
    },
  ];

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="podcasts-groups-view-content">
        <MaintenanceView 
          primaryKey={"id"}
          primaryNameKey={"title"}
          menuConfig={{
            buttonNew: { visible: !!user && user.grants.podcasts_groups },
            buttonEdit: { visible: !!user && user.grants.podcasts_groups },
            buttonDelete: { visible: !!user && user.grants.podcasts_groups },
          }}
          gridConfig={{ 
            filters, 
            sorters, 
            columns,
            title: "Llista de <b>GRUPS DE PODCASTS</b>",
          }}
          reducerName="podcastsGroupsReducer"
          itemNameSingular={itemNameSingular}
          itemIsMale={true}
          actions={podcastsGroupsActions} 
          setIsLoading={setIsLoading}
          setRefreshData={setRefreshData}
          refreshData={refreshData}
          isMultiRowSelection={true}
          page={"podcasts_groups"}
        />
      </div>
    </MainLayout>
  );
};

export default PodcastsGroupsView;
